module.exports = __webpack_public_path__ + "img/me.a20f67a3.png";